import customAxios from "../../customHook/customAxios";
import { getAuthHeader } from "../../utils";

export const v3_project_wise_drawings = async (projectId) => {
    const url = `/v3/drawings/${projectId}`;
    const response = await customAxios.get(url, getAuthHeader());
    return response.data;
};

export const v3_create_drawing = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/drawing`;
    return customAxios.post(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v3_edit_drawing = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/drawing`;
    return customAxios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}



export const v3_drawing = async (payload) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v3/drawing?projectId=${payload.projectId}&page=${payload.page}&limit=${payload.limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
